import React, { useContext, useState, useRef, useEffect } from "react";
import { AudioContext } from "../../services/AudioContext";
import { RadioContext } from "../../services/RadioProvider";
import useSyncedTrack from "../../services/useSyncedTrack";
import "./MRadioPlayerCoverFrame.css";

export default function MRadioPlayerCoverFrame() {
    const coverRef = useRef(null);
    const { nowPlaying } = useContext(RadioContext);
    const audioContext = useContext(AudioContext);
    const [initialTrack, setInitialTrack] = useState(null);

    const coverEffects = ["m-fade", "m-slide", "m-zoom"];
    const getRandomEffect = () => coverEffects[Math.floor(Math.random() * coverEffects.length)];

    const audioTimeMs = audioContext?.audioTimeMs ?? 0;
    const playbackState = audioContext?.playbackState;
    const syncedTrack = useSyncedTrack(nowPlaying, audioTimeMs, playbackState);

    useEffect(() => {
        const firstTrack = nowPlaying?.history?.[0];
        if (firstTrack) {
            setInitialTrack(firstTrack);
        }
    }, [nowPlaying]);

    const currentTrack = syncedTrack || initialTrack;

    useEffect(() => {
        if (coverRef.current && currentTrack?.coverUrl) {
            coverRef.current.className = "d-cover " + getRandomEffect();
        }
    }, [currentTrack?.coverUrl]);

    const artist = currentTrack?.artist || "";
    const songTitle = currentTrack?.title || "";
    const coverUrl = currentTrack?.coverUrl || "";
    const modifiedCoverUrl = coverUrl;

    return (
        <div className="m-outer-frame">
            <div className="m-cover-frame">
                <div id="frame" style={{ backgroundImage: `url(${coverUrl})` }} ></div>
                {coverUrl && <img ref={coverRef} className="m-cover m-fade" src={modifiedCoverUrl} alt="Cover" />}
                <div className="m-title">
                    <div className="m-title-info">
                        LIVE PLAYING TRACK
                    </div>
                    <div className="underline"></div>
                    <div className="m-title-artist">
                        {artist}
                    </div>
                    <div className="m-title-title">
                        {songTitle}
                    </div>
                    <div className="underline"></div>
                </div>
            </div>
        </div>

    );
}